import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AudienciaService} from "../../services/audiencia-service";
import {ToastrService} from "ngx-toastr";
import { NovoComponent } from '../novo/novo.component';
import { DetalhesComponent } from '../detalhes/detalhes.component';

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoComponent) novoComponente: NovoComponent;
  @ViewChild(DetalhesComponent) detalhesComponente: DetalhesComponent;
  loading = true;
  itens: any[] = [];
  paginaAtual = 1;

  constructor(private audienciaService: AudienciaService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.buscarLista();

    this.route.queryParams.subscribe(params => {
      const detalheId = Number(params['detalheId']);
      if (detalheId) {
        // Abrir modal de detalhes automaticamente quando chamado com queryParam
        setTimeout(() => this.abrirModalDetalhes(detalheId));
      }
    });
  }

  getStatusDescricao(status: number): string {
    switch (status) {
      case 0: return 'Agendada';
      case 1: return 'Realizada';
      case 2: return 'Cancelada';
      default: return '—';
    }
  }

  abrirModal(){
    this.novoComponente.showModal();
  }

  abrirModalDetalhes(id: number){
    this.detalhesComponente.abrirModal(id);
  }

  buscarLista(){
    this.loading = true;
    this.audienciaService.buscarPorOrigem().subscribe(
          (response: any) => {
            this.itens = response.dados.itens;
            this.loading = false;
          },
          (error: any) => {
            this.toastr.error('Erro ao listar audiências');
            this.loading = false;
          }
        );
  }

}
